import { Check } from './Check';
import { WeighingType } from './weighing-type.enum';
import { TransportScope } from "src/tmc-yard/common/model/transport.model";

export class Transport {
    id: number;
    numberPlate: string;
    name: string;
    carrier: string;
    allowEntrance: boolean;
    checks: Check[];
    identifier: string;
    transportScope: TransportScope;
    weighingType: WeighingType;
    weight: number;
    autoWeight: number;
    autoWeightSource: string;
}
